import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { API_ENDPOINTS } from "../../config/utilityApiConfig";

const FALLBACK_PATH = "/utility/scenarios";

function UtilityLatestResultRedirect() {
  const [latestCaseId, setLatestCaseId] = useState(undefined);

  useEffect(() => {
    const run = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get(API_ENDPOINTS.mdhdAnalysisCases, {
          headers: token ? { Authorization: `Token ${token}` } : {},
        });
        const cases = Array.isArray(response.data) ? response.data : [];
        setLatestCaseId(cases[0]?.id ?? null);
      } catch {
        setLatestCaseId(null);
      }
    };
    run();
  }, []);

  if (latestCaseId === undefined) {
    return null;
  }

  if (!latestCaseId) {
    return <Navigate to={FALLBACK_PATH} replace />;
  }

  return <Navigate to={`/utility/scenarios/cases/${latestCaseId}`} replace />;
}

export default UtilityLatestResultRedirect;
